import React, { FC } from "react";
import "./index.scss";
import "./v2.scss";

interface Props {
  title: string;
  subTitle: string;
  buttonLink: string;
  buttonText: string;
  buttonTarget?: string;
}

const SignupBanner: FC<Props> = ({
  title,
  subTitle,
  buttonLink,
  buttonTarget = "_self",
  buttonText
}) => {
  return (
    <div className="signup-banner">
      <div className="signup-banner__info">
        <div className="signup-banner__logo">
          <svg
            width="60"
            height="61"
            viewBox="0 0 60 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 0.779297C13.4699 0.779297 0 14.1758 0 30.7793C0 47.3828 13.4287 60.7793 30 60.7793C46.5713 60.7793 60 47.3323 60 30.7793C60 14.2263 46.5438 0.779297 30 0.779297ZM28.408 29.1919H16.2502C16.4566 24.4481 17.6128 19.8327 19.6131 15.6118H28.408V29.1919ZM28.408 45.9468H19.6085C17.6128 41.7259 16.4566 37.1151 16.2502 32.3667H28.408V45.9468ZM28.408 57.8018C25.5911 55.3519 23.1962 52.2505 21.3106 49.1216H28.408V57.8018ZM21.3152 12.437C23.2008 9.30354 25.5957 6.20673 28.4126 3.75682V12.437H21.3152ZM23.3247 4.56887C21.1133 6.95914 19.2277 9.60633 17.7045 12.437H10.13C13.6213 8.65206 18.1771 5.87182 23.3247 4.56887ZM7.60667 15.6118H16.1722C14.3462 19.874 13.291 24.4756 13.1075 29.1919H3.00964C3.29408 24.1774 4.95489 19.5299 7.61126 15.6118M13.1075 32.3667C13.2956 37.083 14.3508 41.6846 16.1722 45.9468H7.60667C4.9503 42.0287 3.2895 37.3812 3.00505 32.3667H13.1029H13.1075ZM10.13 49.1216H17.7C19.2277 51.9523 21.1041 54.5994 23.3201 56.9897C18.1817 55.6776 13.6213 52.8974 10.13 49.1216ZM31.592 57.7743V3.78434C37.8544 4.14678 43.5434 6.63799 47.9431 10.5423C43.7269 14.7539 40.1713 22.6909 40.1713 30.7747C40.1713 38.8585 43.7911 46.8643 47.9431 51.0072C43.5434 54.9114 37.8498 57.4026 31.592 57.7651M52.3933 45.9468C51.7189 46.9331 50.994 47.8691 50.2049 48.7545C45.7547 43.7583 43.3598 37.3675 43.3598 30.7793C43.3598 24.1911 45.7639 17.7911 50.2049 12.8041C54.7377 17.892 57.0408 24.3058 57.0408 30.7793C57.0408 36.0553 55.5085 41.3497 52.3933 45.9468Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div className="signup-banner__details">
          <div className="signup-banner__title">{title}</div>
          <div className="signup-banner__sub-title">{subTitle}</div>
        </div>
      </div>
      <a href={buttonLink} target={buttonTarget} className="signup-banner__btn">
        {buttonText}
        <svg
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.737549 13.5168L6.46255 7.7793L0.737549 2.0418L2.50005 0.279297L10.0001 7.7793L2.50005 15.2793L0.737549 13.5168Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </div>
  );
};

export default SignupBanner;
